import {
  CLEAR_PREDICTION,
  DEFAULT_DICTIONARY_GET_CONTENT,
  DEFAULT_DICTIONARY_GET_CONTENT_FAILED,
  DEFAULT_DICTIONARY_GET_CONTENT_SUCCESS,
  GET_PREDICTION,
  GET_PREDICTION_FAILED,
  GET_PREDICTION_SUCCESS,
  MEDDRA_CHILDREN_GET_CONTENT,
  MEDDRA_CHILDREN_GET_CONTENT_FAILED,
  MEDDRA_CHILDREN_GET_CONTENT_SUCCESS,
  MEDDRA_GET_CONTENT,
  MEDDRA_GET_CONTENT_FAILED,
  MEDDRA_GET_CONTENT_SUCCESS,
} from '../actions/RegulatoryTermsActions';

const initialState = {
  MEDDRADictionary: [],
  defaultDictionary: [],
  MEDDRAFilteredDictionary: [],
  defaultFilteredDictionary: [],
  predictionResults: {},
  loading: false,
  isNewDict: false,
  hasError: false,
  predictionLoading: false,
  hasPredictionRequestError: false,
};

const mergeDictionary = (dictionary, path, dataToMerge) => {
  const newDictionary = dictionary.map((item) => {
    if (item.Code === path[0].Code && item.ParentCode === path[0].ParentCode) {
      if (path.length === 1) {
        return { ...dataToMerge, parentNode: item };
      }
      const Children = mergeDictionary(item.Children, path.slice(1), dataToMerge);
      return { ...item, Children };
    }

    return item;
  });

  return newDictionary;
};

export default (state = initialState, action) => {
  const { data, path, isSearchedData } = action.payload || {};
  const { MEDDRADictionary, defaultDictionary } = state;

  switch (action.type) {
    case MEDDRA_GET_CONTENT:
      return {
        ...state,
        MEDDRADictionary: [],
        MEDDRAFilteredDictionary: [],
        loading: true,
        hasError: false,
      };
    case MEDDRA_CHILDREN_GET_CONTENT:
      return {
        ...state,
        MEDDRAFilteredDictionary: [],
        loading: true,
        hasError: false,
      };
    case DEFAULT_DICTIONARY_GET_CONTENT:
      return {
        ...state,
        defaultFilteredDictionary: [],
        loading: true,
        hasError: false,
      };
    case GET_PREDICTION:
      return {
        ...state,
        predictionResults: {},
        predictionLoading: true,
        hasPredictionRequestError: false,
      };
    case MEDDRA_GET_CONTENT_SUCCESS:
      return {
        ...state,
        MEDDRADictionary: data,
        isNewDict: true,
        loading: false,
        hasError: false,
      };
    case MEDDRA_CHILDREN_GET_CONTENT_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const newDict = mergeDictionary(MEDDRADictionary, path, data);

      return {
        ...state,
        MEDDRADictionary: newDict,
        isNewDict: false,
        loading: false,
        hasError: false,
      };
    case DEFAULT_DICTIONARY_GET_CONTENT_SUCCESS:
      return {
        ...state,
        defaultDictionary: isSearchedData ? defaultDictionary : data,
        defaultFilteredDictionary: isSearchedData ? data : [],
        loading: false,
        hasError: false,
        hasPredictionRequestError: false,
      };
    case GET_PREDICTION_SUCCESS:
      return {
        ...state,
        predictionResults: data ?? {},
        predictionLoading: false,
        hasPredictionRequestError: false,
      };

    case MEDDRA_GET_CONTENT_FAILED:
    case MEDDRA_CHILDREN_GET_CONTENT_FAILED:
    case DEFAULT_DICTIONARY_GET_CONTENT_FAILED:
      return {
        ...state,
        loading: false,
        hasError: true,
        predictionLoading: false,
        hasPredictionRequestError: true,
      };
    case GET_PREDICTION_FAILED:
      return {
        ...state,
        predictionLoading: false,
        hasPredictionRequestError: true,
      };
    case CLEAR_PREDICTION:
      return {
        ...state,
        predictionResults: {},
        predictionLoading: false,
        hasPredictionRequestError: false,
      };
    default:
      return state;
  }
};
